import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { WizumenAdditional } from '../wizumen-models';

//Cards de productos adicionales
@Component({
  selector: 'wizumen-additional',
  template: `
    <div class="wizumen-additional wizumen-additional-{{index}} eva-3-card -eva-3-shadow-line">
        <span class="wizumen-additional-title-wrapper flex align-center">
            <i class="eva-3-icon-{{wizumenAdditional.icon}} eva-icon -eva-3-tc-brand-primary-4 -eva-3-mr-xsm"></i>
            <em class="wizumen-additional-title -eva-3-bold">
                {{wizumenAdditional.title}}
            </em>
        </span>

        <p class="wizumen-additional-text">
            {{wizumenAdditional.text}}
        </p>

        <a class="wizumen-additional-link eva-3-link home-ui-track-click"
            target="_blank"
            href="{{wizumenAdditional.href}}"
            (click)="trackAdditionalClick()">
            {{wizumenAdditional.link_text}}
        </a>
    </div>
  `,
  styleUrls: ['../wizumen.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenAdditionalComponent {
  @Input() wizumenAdditional: WizumenAdditional;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() index: number;
  @Input() toCityCode: string;
  @Input() uniqueId: string;

  constructor(private upaService: UpaService) {}

  public trackAdditionalClick() {
    this.upaService.trackClickTopic({
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      target: UpaTarget.WIZUMEN_MODAL,
      label: this.wizumenAdditional.type,
      href: this.wizumenAdditional.href,
      dc: this.toCityCode,
      positionIndex: this.index,
      uniqueId: this.uniqueId
    })
  }

}